import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { HelmetProvider } from 'react-helmet-async';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { allRoutes } from 'src/routes/sections';

import App from './app';

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://992ce3b6128b53cbcf51ce10134c7e7b@sentry.init-one.fr/6',
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
          'localhost',
          /^https:\/\/terranum-preprod-supabase\.init-one\.fr\/rest\/v1/,
        ],
      }),
      new Sentry.Replay(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

const browserRouter = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: allRoutes,
  },
]);

const SentryRouter = Sentry.withSentryReactRouterV6Routing(RouterProvider);

root.render(
  <HelmetProvider>
    <Suspense>
      <SentryRouter router={browserRouter} />
    </Suspense>
  </HelmetProvider>
);
